"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sound = void 0;
const SoundSystem_1 = require("./SoundSystem");
class Sound {
    constructor(buffer) {
        this.index = -1;
        this.name = '';
        this.buffer = buffer;
    }
    static create(buffer) {
        return new Promise((resolve, reject) => {
            SoundSystem_1.SoundSystem.getContext().decodeAudioData(buffer, (buffer) => {
                resolve(new Sound(buffer));
            }, (err) => {
                reject(err);
            });
        });
    }
}
exports.Sound = Sound;
